export default __webpack_public_path__ + "static/media/design2.477516f1.png";